export default __webpack_public_path__ + "fb88f7962687157157f6bedb401e228e.gif";